"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var models_1 = require("./models");

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var SortButton_meta_1 = require("./SortButton.meta");

var mobx_1 = require("mobx");

var Button_1 = __importDefault(require("../Button"));

var SortButton =
/** @class */
function (_super) {
  __extends(SortButton, _super);

  function SortButton(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = SortButton_meta_1.SORT_BUTTON_CATEGORY_KEY;
    _this.componentKey = SortButton_meta_1.SORT_BUTTON_COMPONENT_KEY;

    _this.handleToggle = function (event) {
      return __awaiter(_this, void 0, void 0, function () {
        var onChange;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              event.stopPropagation();

              if (this.direction === models_1.SortButtonDirection.unset) {
                this.direction = models_1.SortButtonDirection.ascending;
              } else if (this.direction === models_1.SortButtonDirection.ascending) {
                this.direction = models_1.SortButtonDirection.descending;
              } else if (this.direction === models_1.SortButtonDirection.descending) {
                this.direction = models_1.SortButtonDirection.unset;
              }

              onChange = this.props.onChange;
              if (!onChange) return [3
              /*break*/
              , 2];
              return [4
              /*yield*/
              , onChange(this.props.payload, this.direction)];

            case 1:
              _a.sent();

              _a.label = 2;

            case 2:
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    _this.setDirection = function (direction) {
      _this.direction = direction || models_1.SortButtonDirection.unset;
    };

    _this.direction = models_1.SortButtonDirection.unset;

    _this.setDirection(props.direction);

    return _this;
  }

  Object.defineProperty(SortButton.prototype, "payload", {
    get: function get() {
      return this.props.payload;
    },
    enumerable: true,
    configurable: true
  });

  SortButton.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.direction !== this.props.direction) {
      this.setDirection(this.props.direction);
    }
  };

  Object.defineProperty(SortButton.prototype, "iconLoadingDefault", {
    get: function get() {
      return {
        asset: 'base.sortButton.loading',
        className: 'ksys-sort-button-loading',
        accessibilityText: 'loading'
      };
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(SortButton.prototype, "iconAscendingDefault", {
    get: function get() {
      return {
        asset: 'base.sortButton.ascending',
        accessibilityText: 'ascending'
      };
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(SortButton.prototype, "iconDescendingDefault", {
    get: function get() {
      return {
        asset: 'base.sortButton.descending',
        accessibilityText: 'descending'
      };
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(SortButton.prototype, "iconUnsetDefault", {
    get: function get() {
      return {
        asset: 'base.sortButton.unset',
        accessibilityText: 'unset'
      };
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(SortButton.prototype, "iconProps", {
    get: function get() {
      var _a = this.props,
          _b = _a.loading,
          loading = _b === void 0 ? false : _b,
          iconAscending = _a.iconAscending,
          iconDescending = _a.iconDescending,
          iconUnset = _a.iconUnset,
          iconLoading = _a.iconLoading;

      if (loading) {
        return iconLoading || this.iconLoadingDefault;
      }

      if (this.direction === models_1.SortButtonDirection.ascending) {
        return iconAscending || this.iconAscendingDefault;
      }

      if (this.direction === models_1.SortButtonDirection.descending) {
        return iconDescending || this.iconDescendingDefault;
      }

      return iconUnset || this.iconUnsetDefault;
    },
    enumerable: true,
    configurable: true
  });

  SortButton.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        _b = _a.buttonProps,
        buttonProps = _b === void 0 ? {} : _b,
        _c = _a.loading,
        loading = _c === void 0 ? false : _c;
    var iconProps = this.iconProps;
    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, react_1.default.createElement(Button_1.default, __assign({}, buttonProps, {
      disabled: loading,
      onClick: this.handleToggle,
      iconProps: iconProps,
      "aria-live": "polite"
    })));
  };

  __decorate([mobx_1.computed], SortButton.prototype, "payload", null);

  __decorate([mobx_1.action], SortButton.prototype, "handleToggle", void 0);

  __decorate([mobx_1.action], SortButton.prototype, "setDirection", void 0);

  __decorate([mobx_1.observable.ref], SortButton.prototype, "direction", void 0);

  __decorate([mobx_1.computed], SortButton.prototype, "iconProps", null);

  SortButton = __decorate([mobx_react_1.observer], SortButton);
  return SortButton;
}(shared_1.ComponentBase);

exports.SortButton = SortButton;
exports.default = shared_1.InjectedStyledComponent(SortButton, SortButton_meta_1.SORT_BUTTON_CATEGORY_KEY, SortButton_meta_1.SORT_BUTTON_COMPONENT_KEY);